import * as yup from "yup";

export const performerSchema = yup
  .object({
    first_name: yup.string().required().default(""),
    last_name: yup.string().required().default(""),
    instagram: yup.string().default("").nullable(),
    email: yup.string().default("").nullable(),
    phone: yup.string().default("").nullable(),
  })
  .required();
